import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { PROFILE } from 'src/routes/routes';
import CurrentUserContext from 'src/utils/context/CurrentUserContext';
import s from './UserMenu.styles';

const UserMenu = () => {
  const { firstName, lastName } = useContext(CurrentUserContext);
  const userNameInitials = `${firstName ? firstName[0].toUpperCase() : ''}${lastName ? lastName[0].toUpperCase() : ''}`;

  return (
    <s.Menu>
      <s.Item>
        <Link to={PROFILE}>
          <s.Label>{userNameInitials}</s.Label>
        </Link>
      </s.Item>
    </s.Menu>
  );
};

export default React.memo(UserMenu);
